import api from "@/services/api";
import { formatDateToString } from "@/utils";

const { get, patch, post } = api.getPrefixedMethods("patients");

export const patientService = {
  search({ firstName, lastName, phoneNumber, dob, address, externalId }, clientCompany) {
    return get("", {
      params: {
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber,
        dob: dob ? formatDateToString(dob) : null,
        address: address,
        external_id: externalId,
        client_company: clientCompany,
      },
    });
  },
  patchPatient(id, { firstName, lastName, phoneNumber, dob, middleName, suffix, externalId }) {
    return patch(`${id}/`, {
      firstName,
      lastName,
      phoneNumber,
      dob: dob ? formatDateToString(dob) : null,
      middleName,
      suffix,
      externalId,
    });
  },
  postPatient({ firstName, lastName, phoneNumber, dob, clientCompany, middleName, suffix }) {
    return post("", {
      firstName,
      lastName,
      phoneNumber,
      dob: dob ? formatDateToString(dob) : null,
      clientCompany,
      middleName,
      suffix,
    });
  },
  updateExternalId(id, externalId) {
    return patch(`${id}/external-id/`, {
      external_id: externalId,
    });
  },
  getByExternalId(externalId) {
    return get(`external-id/${encodeURIComponent(externalId)}/`);
  },
};
